import { useEffect, useRef } from "react";

/*
 * Shared behavior for the full-screen panels (Contact, About): while open,
 * the page behind doesn't scroll, focus moves to the × button, and Escape
 * closes it. On close, focus goes back to the button that opened it.
 */
export default function useOverlay(open, onClose, closeRef) {
  // Latest onClose, without re-running the effect below when it changes
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const opener = document.activeElement;
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();

    const onKey = (event) => {
      if (event.key === "Escape") onCloseRef.current();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = overflow;
      opener?.focus?.();
    };
  }, [open, closeRef]);
}
